import { createAction } from "@reduxjs/toolkit";
import { Dayjs } from "dayjs";

import {
    HouseholdClaim,
    HouseholdClaimState,
} from "src/containers/household-claim/models/claim.model";
import { HouseholdClaimActionTypes as types } from "src/redux/claim/household/action-types";

export interface HouseholdClaimLoadSummariesAction {
    type: typeof types.CLAIM_LOAD_SUMMARIES;
    payload: {
        claimState: HouseholdClaimState;
        initDate: Dayjs;
        endDate: Dayjs;
    };
}

export interface HouseholdClaimFillSummariesAction {
    type: typeof types.CLAIM_FILL_SUMMARIES;
    payload: HouseholdClaim[];
}

export interface HouseholdClaimErrorSummariesAction {
    type: typeof types.CLAIM_ERROR_SUMMARIES;
    payload: Error;
}

export const householdClaimLoadSummaries = createAction(
    types.CLAIM_LOAD_SUMMARIES,
    (claimState: HouseholdClaimState, initDate: Dayjs, endDate: Dayjs) => ({
        payload: { claimState, initDate, endDate },
    })
);

export const householdClaimFillSummaries = createAction(
    types.CLAIM_FILL_SUMMARIES,
    (payload) => {
        return { payload };
    }
);

export const householdClaimErrorSummaries = createAction(
    types.CLAIM_ERROR_SUMMARIES,
    (payload) => {
        return { payload };
    }
);
